import _ from 'lodash';

export const getInitialsFromName = (name: string) => {
    const [head, ...tail] = _.words(name);
    return [head, _.last(tail)].map(_.head).join('').toUpperCase();
};
